module.exports = __webpack_public_path__ + "img/dcs_pic_4.de131d49.jpg";